import { isRemember } from "@/helper/RememberMe";

export default function hasToken(): string | null {
  return isRemember()
    ? localStorage.getItem("access_token")
    : sessionStorage.getItem("access_token");
}
